import { render, staticRenderFns } from "./CategoryCheckbox.vue?vue&type=template&id=efef3ea0&"
import script from "./CategoryCheckbox.vue?vue&type=script&lang=ts&"
export * from "./CategoryCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryCheckbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports